import { createAction, props } from '@ngrx/store';
import type { IFamily } from '../../library/becks-family';
import type { GradeSize, PackageType, Trait, TreatmentType } from '../../shared/models/product.interface';

export const loadProductFamilies = createAction('[Shared: Products] Load Product Families');
export const loadProductFamiliesSuccess = createAction(
  '[Shared: Products] Load Product Families Success',
  props<{ data: IFamily[] }>()
);
export const loadProductFamiliesFailure = createAction(
  '[Shared: Products] Load Product Families Failure',
  props<{ error: unknown }>()
);

export const loadProductTraits = createAction('[Shared: Products] Load Product Traits');
export const loadProductTraitsSuccess = createAction(
  '[Shared: Products] Load Product Traits Success',
  props<{ data: Trait[] }>()
);
export const loadProductTraitsFailure = createAction(
  '[Shared: Products] Load Product Traits Failure',
  props<{ error: unknown }>()
);

export const loadProductTreatments = createAction('[Shared: Products] Load Product Treatments');
export const loadProductTreatmentsSuccess = createAction(
  '[Shared: Products] Load Product Treatments Success',
  props<{ data: TreatmentType[] }>()
);
export const loadProductTreatmentsFailure = createAction(
  '[Shared: Products] Load Product Treatments Failure',
  props<{ error: unknown }>()
);

export const loadProductPackageTypes = createAction('[Shared: Products] Load Product Package Types');
export const loadProductPackageTypesSuccess = createAction(
  '[Shared: Products] Load Product Package Types Success',
  props<{ data: PackageType[] }>()
);
export const loadProductPackageTypesFailure = createAction(
  '[Shared: Products] Load Product Package Types Failure',
  props<{ error: unknown }>()
);

export const loadProductGradeSizes = createAction('[Shared: Products] Load Product Grade Sizes');
export const loadProductGradeSizesSuccess = createAction(
  '[Shared: Products] Load Product Grade Sizes Success',
  props<{ data: GradeSize[] }>()
);
export const loadProductGradeSizesFailure = createAction(
  '[Shared: Products] Load Product Grade Sizes Failure',
  props<{ error: unknown }>()
);
